import "core-js/modules/es.array.reverse.js";
var _dec, _class, _class2, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import classNames from "classnames";
import { isEmpty, merge } from "lodash-es";
import { action, computed, makeObservable, observable, reaction, runInAction } from "mobx";
import { observer } from "mobx-react";
import Mustache from "mustache";
import { Component } from "react";
import { withTranslation } from "react-i18next";
import styled from "styled-components";
import Ellipsoid from "terriajs-cesium/Source/Core/Ellipsoid";
import JulianDate from "terriajs-cesium/Source/Core/JulianDate";
import CesiumMath from "terriajs-cesium/Source/Core/Math";
import TerriaError from "../../Core/TerriaError";
import filterOutUndefined from "../../Core/filterOutUndefined";
import isDefined from "../../Core/isDefined";
import { getName } from "../../ModelMixins/CatalogMemberMixin";
import DiscretelyTimeVaryingMixin from "../../ModelMixins/DiscretelyTimeVaryingMixin";
import MappableMixin from "../../ModelMixins/MappableMixin";
import TableMixin from "../../ModelMixins/TableMixin";
import TimeVarying from "../../ModelMixins/TimeVarying";
import FeatureInfoContext from "../../Models/Feature/FeatureInfoContext";
import Icon from "../../Styled/Icon";
import { withViewState } from "../Context";
import parseCustomMarkdownToReact from "../Custom/parseCustomMarkdownToReact";
import FeatureInfoDownload from "./FeatureInfoDownload";
import FeatureInfoPanelButton from "./FeatureInfoPanelButton";
import Styles from "./feature-info-section.scss";
import { generateCesiumInfoHTMLFromProperties } from "./generateCesiumInfoHTMLFromProperties";
import getFeatureProperties from "./getFeatureProperties";
import { mustacheFormatDateTime, mustacheFormatNumberFunction, mustacheRenderPartialByName, mustacheURLEncodeText, mustacheURLEncodeTextComponent } from "./mustacheExpressions";

// We use Mustache templates inside React views, where React does the escaping; don't escape twice, or eg. " => &quot;
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
Mustache.escape = function (string) {
  return string;
};
export let FeatureInfoSection = (_dec = observable.ref, observer(_class = (_class2 = class FeatureInfoSection extends Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "templateReactionDisposer", void 0);
    _defineProperty(this, "removeFeatureChangedSubscription", void 0);
    /** Rendered feature info template - this is set using reaction.
     * We can't use `@computed` values for custom templates - as CustomComponents may cause side-effects.
     * For example
     * - A CsvChartCustomComponent will create a new CsvCatalogItem and set traits
     * See `rawDataReactNode` for rendered raw data
     */
    _initializerDefineProperty(this, "templatedFeatureInfoReactNode", _descriptor, this);
    _defineProperty(this, "noInfoRef", null);
    _initializerDefineProperty(this, "showRawData", _descriptor2, this);
    _initializerDefineProperty(this, "observableFeature", _descriptor3, this);
    _initializerDefineProperty(this, "observablePosition", _descriptor4, this);
    _initializerDefineProperty(this, "observableCatalogItem", _descriptor5, this);
    // Note this may not be known (eg. WFS).
    _initializerDefineProperty(this, "observableViewState", _descriptor6, this);
    /** See `setFeatureChangedCounter` */
    _initializerDefineProperty(this, "featureChangedCounter", _descriptor7, this);
    makeObservable(this);
    this.observableFeature = props.feature;
    this.observablePosition = props.position;
    this.observableCatalogItem = props.catalogItem;
    this.observableViewState = props.viewState;
  }
  componentDidMount() {
    this.templateReactionDisposer = reaction(() => [this.observableFeature, this.observableCatalogItem.featureInfoTemplate.template, this.observableCatalogItem.featureInfoTemplate.partials,
    // Note `mustacheContextData` will trigger update when `currentTime` changes (through this.featureProperties)
    this.mustacheContextData], () => {
      if (this.observableCatalogItem.featureInfoTemplate.template && this.mustacheContextData) {
        this.templatedFeatureInfoReactNode = parseCustomMarkdownToReact(Mustache.render(this.observableCatalogItem.featureInfoTemplate.template, this.mustacheContextData, this.observableCatalogItem.featureInfoTemplate.partials), this.parseMarkdownContextData);
      } else {
        this.templatedFeatureInfoReactNode = undefined;
      }
    }, {
      fireImmediately: true
    });
    this.setFeatureChangedCounter(this.observableFeature);
  }
  componentDidUpdate(prevProps) {
    runInAction(() => {
      this.observableFeature = this.props.feature;
      this.observablePosition = this.props.position;
      this.observableCatalogItem = this.props.catalogItem;
      this.observableViewState = this.props.viewState;
    });
    if (prevProps.feature !== this.props.feature) {
      this.setFeatureChangedCounter(this.props.feature);
    }
  }

  /** Dispose of reaction and cesium feature change event listener */
  componentWillUnmount() {
    var _this$templateReactio, _this$removeFeatureCh;
    (_this$templateReactio = this.templateReactionDisposer) === null || _this$templateReactio === void 0 || _this$templateReactio.call(this);
    (_this$removeFeatureCh = this.removeFeatureChangedSubscription) === null || _this$removeFeatureCh === void 0 || _this$removeFeatureCh.call(this);
  }

  /**
   * We need to force `featureProperties` to re-compute when Cesium Feature properties change.
   * We use `featureChangedCounter` and increment it every change
   */
  setFeatureChangedCounter(feature) {
    var _this$removeFeatureCh2;
    (_this$removeFeatureCh2 = this.removeFeatureChangedSubscription) === null || _this$removeFeatureCh2 === void 0 || _this$removeFeatureCh2.call(this);
    this.removeFeatureChangedSubscription = feature.definitionChanged.addEventListener((_changedFeature => {
      runInAction(() => {
        this.featureChangedCounter++;
      });
    }).bind(this));
  }
  get currentTimeIfAvailable() {
    return TimeVarying.is(this.observableCatalogItem) ? this.observableCatalogItem.currentTimeAsJulianDate : undefined;
  }
  get featureProperties() {
    var _this$currentTimeIfAv;
    // Force computed to re-calculate when cesium feature properties change
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    this.featureChangedCounter;
    return getFeatureProperties(this.observableFeature, (_this$currentTimeIfAv = this.currentTimeIfAvailable) !== null && _this$currentTimeIfAv !== void 0 ? _this$currentTimeIfAv : JulianDate.now(), MappableMixin.isMixedInto(this.observableCatalogItem) && this.observableCatalogItem.featureInfoTemplate.formats ? this.observableCatalogItem.featureInfoTemplate.formats : undefined);
  }

  /** This monstrosity contains properties which can be used by Mustache templates:
   * - All feature properties
   * - `properties` = array of key:value from feature properties
   * - `terria` magical object
   *     - a bunch of custom mustache expressions
   *       - `partialByName`
   *       - `formatNumber`
   *       - `formatDateTime`
   *       - `urlEncodeComponent`
   *       - `urlEncode`
   *     - `coords` with `latitude` and `longitude`
   *     - `currentTime`
   *     - `rawDataTable` contains markdown table
   *  - properties provided by catalog item through `featureInfoContext` function
   */
  get mustacheContextData() {
    var _this$observableCatal, _this$observableCatal2;
    const propertyValues = Object.assign({}, this.featureProperties);

    // Properties accessible as {name, value} array; useful when you want
    // to iterate anonymous property values in the mustache template.
    const properties = Object.entries(propertyValues).map(_ref => {
      let [name, value] = _ref;
      return {
        name,
        value
      };
    });
    const propertyData = _objectSpread(_objectSpread({}, propertyValues), {}, {
      properties,
      feature: this.observableFeature
    });
    const terria = {
      partialByName: mustacheRenderPartialByName((_this$observableCatal = (_this$observableCatal2 = this.observableCatalogItem.featureInfoTemplate) === null || _this$observableCatal2 === void 0 ? void 0 : _this$observableCatal2.partials) !== null && _this$observableCatal !== void 0 ? _this$observableCatal : {}, propertyData),
      formatNumber: mustacheFormatNumberFunction,
      formatDateTime: mustacheFormatDateTime,
      urlEncodeComponent: mustacheURLEncodeTextComponent,
      urlEncode: mustacheURLEncodeText,
      rawDataTable: this.rawDataMarkdown
    };
    if (this.observablePosition) {
      const latLngInRadians = Ellipsoid.WGS84.cartesianToCartographic(this.observablePosition);
      terria.coords = {
        latitude: CesiumMath.toDegrees(latLngInRadians.latitude),
        longitude: CesiumMath.toDegrees(latLngInRadians.longitude)
      };
    }

    // Add currentTime property
    // if discrete - use current discrete time
    // otherwise - use current (continuous) time
    if (DiscretelyTimeVaryingMixin.isMixedInto(this.observableCatalogItem) && this.observableCatalogItem.currentDiscreteJulianDate) {
      terria.currentTime = JulianDate.toDate(this.observableCatalogItem.currentDiscreteJulianDate);
    } else if (TimeVarying.is(this.observableCatalogItem) && this.observableCatalogItem.currentTimeAsJulianDate) {
      terria.currentTime = JulianDate.toDate(this.observableCatalogItem.currentTimeAsJulianDate);
    }

    // Add activeStyle property
    if (TableMixin.isMixedInto(this.observableCatalogItem)) {
      terria.activeStyle = {
        id: this.observableCatalogItem.activeStyle
      };
    }

    // If catalog item has featureInfoContext function
    // Merge it into other properties
    if (FeatureInfoContext.is(this.observableCatalogItem)) {
      var _this$observableCatal3;
      return merge(_objectSpread(_objectSpread({}, propertyData), {}, {
        terria
      }), (_this$observableCatal3 = this.observableCatalogItem.featureInfoContext(this.observableFeature)) !== null && _this$observableCatal3 !== void 0 ? _this$observableCatal3 : {});
    }
    return _objectSpread(_objectSpread({}, propertyData), {}, {
      terria
    });
  }
  clickHeader() {
    if (isDefined(this.props.onClickHeader)) {
      this.props.onClickHeader(this.observableFeature);
    }
  }

  /** Context object passed into "parseCustomMarkdownToReact"
   * These will get passed to CustomComponents (eg CsvChartCustomComponent)
   */
  get parseMarkdownContextData() {
    return {
      terria: this.observableViewState.terria,
      catalogItem: this.observableCatalogItem,
      feature: this.observableFeature
    };
  }

  /** Get raw data table as markdown string
   *
   * Will use feature.description if defined
   * Otherwise, will generate cesium info HTML table from feature properties
   */
  get rawDataMarkdown() {
    var _this$currentTimeIfAv2, _feature$description;
    const feature = this.observableFeature;
    const currentTime = (_this$currentTimeIfAv2 = this.currentTimeIfAvailable) !== null && _this$currentTimeIfAv2 !== void 0 ? _this$currentTimeIfAv2 : JulianDate.now();
    const description = (_feature$description = feature.description) === null || _feature$description === void 0 ? void 0 : _feature$description.getValue(currentTime);
    if (isDefined(description)) return description;
    if (isDefined(feature.properties)) {
      return generateCesiumInfoHTMLFromProperties(feature.properties, currentTime, MappableMixin.isMixedInto(this.observableCatalogItem) ? this.observableCatalogItem.showStringIfPropertyValueIsNull : undefined);
    }
  }

  /** Get Raw data as ReactNode.
   * Note: this can be computed - as no custom components are used which cause side-effects (eg CSVChartCustomComponent)
   * See `templatedFeatureInfoReactNode` for rendered feature info template
   */
  get rawFeatureInfoReactNode() {
    if (this.rawDataMarkdown) return parseCustomMarkdownToReact(this.rawDataMarkdown, this.parseMarkdownContextData);
  }
  toggleRawData() {
    this.showRawData = !this.showRawData;
  }
  get downloadableData() {
    let fileName = getName(this.observableCatalogItem);

    // Add the Lat, Lon to the baseFilename if it is possible and not already present.
    if (this.observablePosition) {
      const position = Ellipsoid.WGS84.cartesianToCartographic(this.observablePosition);
      const latitude = CesiumMath.toDegrees(position.latitude);
      const longitude = CesiumMath.toDegrees(position.longitude);
      const precision = 5;
      // Check that baseFilename doesn't already contain the lat, lon with the similar or better precision.
      if (!contains(fileName, latitude, precision) || !contains(fileName, longitude, precision)) {
        fileName += " - Lat " + latitude.toFixed(precision) + " Lon " + longitude.toFixed(precision);
      }
    }
    return {
      data: this.featureProperties && !isEmpty(this.featureProperties) ? this.featureProperties : undefined,
      fileName
    };
  }
  get generatedButtons() {
    const buttons = filterOutUndefined(this.observableViewState.featureInfoPanelButtonGenerators.map(generator => {
      try {
        const dim = generator({
          feature: this.observableFeature,
          item: this.observableCatalogItem
        });
        return dim;
      } catch (error) {
        TerriaError.from(error).log();
      }
    }));
    return buttons;
  }
  renderButtons() {
    const {
      t
    } = this.props;
    return /*#__PURE__*/_jsxs(ButtonsContainer, {
      children: [!this.props.printView && this.templatedFeatureInfoReactNode && /*#__PURE__*/_jsx(FeatureInfoPanelButton, {
        onClick: this.toggleRawData.bind(this),
        text: this.showRawData ? t("featureInfo.showCuratedData") : t("featureInfo.showRawData")
      }), this.generatedButtons.map((button, i) => /*#__PURE__*/_jsx(FeatureInfoPanelButton, _objectSpread({}, button), i))]
    });
  }
  render() {
    var _this$currentTimeIfAv3;
    const {
      t
    } = this.props;
    let title;
    if (this.observableCatalogItem.featureInfoTemplate.name) {
      title = Mustache.render(this.observableCatalogItem.featureInfoTemplate.name, this.mustacheContextData, this.observableCatalogItem.featureInfoTemplate.partials);
    } else title = getName(this.observableCatalogItem) + " - " + (this.observableFeature.name || t("featureInfo.siteData"));

    /** Show feature info download if showing raw data - or showing template and `showFeatureInfoDownloadWithTemplate` is true
     */
    const showFeatureInfoDownload = this.showRawData || !this.templatedFeatureInfoReactNode || this.templatedFeatureInfoReactNode && this.observableCatalogItem.featureInfoTemplate.showFeatureInfoDownloadWithTemplate;
    const titleElement = this.props.printView ? /*#__PURE__*/_jsx("h2", {
      children: title
    }) : /*#__PURE__*/_jsxs("button", {
      type: "button",
      onClick: this.clickHeader.bind(this),
      className: Styles.title,
      children: [/*#__PURE__*/_jsx("span", {
        children: title
      }), this.props.isOpen ? /*#__PURE__*/_jsx(Icon, {
        glyph: Icon.GLYPHS.opened
      }) : /*#__PURE__*/_jsx(Icon, {
        glyph: Icon.GLYPHS.closed
      })]
    });

    // If feature is unavailable (or not showing) - show no info message
    if (!this.observableFeature.isAvailable((_this$currentTimeIfAv3 = this.currentTimeIfAvailable) !== null && _this$currentTimeIfAv3 !== void 0 ? _this$currentTimeIfAv3 : JulianDate.now()) || !this.observableFeature.isShowing) {
      return /*#__PURE__*/_jsxs("li", {
        className: classNames(Styles.section),
        children: [titleElement, this.props.isOpen ? /*#__PURE__*/_jsx("section", {
          className: Styles.content,
          children: /*#__PURE__*/_jsx("div", {
            ref: r => {
              this.noInfoRef = r;
            },
            children: t("featureInfo.noInfoAvailable")
          }, "no-info")
        }) : null]
      });
    }
    return /*#__PURE__*/_jsxs("li", {
      className: classNames(Styles.section),
      children: [titleElement, this.props.isOpen ? /*#__PURE__*/_jsxs("section", {
        className: Styles.content,
        children: [this.renderButtons(), /*#__PURE__*/_jsxs("div", {
          children: [this.observableFeature.loadingFeatureInfoUrl ? "Loading" : this.showRawData || !this.templatedFeatureInfoReactNode ? this.rawFeatureInfoReactNode ? this.rawFeatureInfoReactNode : /*#__PURE__*/_jsx("div", {
            ref: r => {
              this.noInfoRef = r;
            },
            children: t("featureInfo.noInfoAvailable")
          }, "no-info") :
          // Show templated feature info
          this.templatedFeatureInfoReactNode,
          // Show FeatureInfoDownload
          !this.props.printView && showFeatureInfoDownload && isDefined(this.downloadableData.data) ? /*#__PURE__*/_jsx(FeatureInfoDownload, {
            data: this.downloadableData.data,
            name: this.downloadableData.fileName
          }, "download") : null]
        })]
      }) : null]
    });
  }
}, _descriptor = _applyDecoratedDescriptor(_class2.prototype, "templatedFeatureInfoReactNode", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return undefined;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "showRawData", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, "observableFeature", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, "observablePosition", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class2.prototype, "observableCatalogItem", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class2.prototype, "observableViewState", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class2.prototype, "featureChangedCounter", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return 0;
  }
}), _applyDecoratedDescriptor(_class2.prototype, "setFeatureChangedCounter", [action], Object.getOwnPropertyDescriptor(_class2.prototype, "setFeatureChangedCounter"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "currentTimeIfAvailable", [computed], Object.getOwnPropertyDescriptor(_class2.prototype, "currentTimeIfAvailable"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "featureProperties", [computed], Object.getOwnPropertyDescriptor(_class2.prototype, "featureProperties"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "mustacheContextData", [computed], Object.getOwnPropertyDescriptor(_class2.prototype, "mustacheContextData"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "parseMarkdownContextData", [computed], Object.getOwnPropertyDescriptor(_class2.prototype, "parseMarkdownContextData"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "rawDataMarkdown", [computed], Object.getOwnPropertyDescriptor(_class2.prototype, "rawDataMarkdown"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "rawFeatureInfoReactNode", [computed], Object.getOwnPropertyDescriptor(_class2.prototype, "rawFeatureInfoReactNode"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "toggleRawData", [action], Object.getOwnPropertyDescriptor(_class2.prototype, "toggleRawData"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "downloadableData", [computed], Object.getOwnPropertyDescriptor(_class2.prototype, "downloadableData"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "generatedButtons", [computed], Object.getOwnPropertyDescriptor(_class2.prototype, "generatedButtons"), _class2.prototype), _class2)) || _class);

// See if text contains the number (to a precision number of digits (after the dp) either fixed up or down on the last digit).
function contains(text, number, precision) {
  // Take Math.ceil or Math.floor and use it to calculate the number with a precision number of digits (after the dp).
  function fixed(round, number) {
    const scale = Math.pow(10, precision);
    return (round(number * scale) / scale).toFixed(precision);
  }
  return text.indexOf(fixed(Math.floor, number)) !== -1 || text.indexOf(fixed(Math.ceil, number)) !== -1;
}
const ButtonsContainer = styled.div.withConfig({
  displayName: "FeatureInfoSection__ButtonsContainer",
  componentId: "sc-w09wbb-0"
})(["display:flex;justify-content:flex-end;padding:7px 0 10px 0;"]);
export default withTranslation()(withViewState(FeatureInfoSection));